<template>
  <in-viewport>
    <section class="artworks-section">
      <grid-container>
        <grid-row>
          <div class="artworks-section__header">
            <border-box>
              <h2 class="artworks-section__heading">
                <text-rotator :text="$t(activeKey)"/>
              </h2>
            </border-box>
          </div>
          <div class="artworks-section__artwork">
            <div class="artworks-section__artwork-item">
              <component
                ref="artworks"
                v-for="(artwork, i) in artworks"
                :key="i"
                :is="artwork.component"
                class="artworks-section__svg"
              />
            </div>
          </div>
        </grid-row>
      </grid-container>
    </section>
  </in-viewport>
</template>

<script>
import Vivus from 'vivus'
import inViewport from 'vue-in-viewport-mixin'

import TextRotator from '@/components/TextRotator'
import ArchitectureArtwork from '@/containers/Home/ArchitectureArtwork'
import PlanningArtwork from '@/containers/Home/PlanningArtwork'
import AnalysisArtwork from '@/containers/Home/AnalysisArtwork'
import PublicSpaceArtwork from '@/containers/Home/PublicSpaceArtwork'
import BorderBox from '@/components/BorderBox'

export default {
  components: {
    BorderBox,
    TextRotator
  },
  mixins: [inViewport],
  data () {
    return {
      currentArtwork: -1,
      visible: false,
      artworks: [
        {
          key: 'architecture',
          component: ArchitectureArtwork,
          duration: 20
        },
        {
          key: 'planning',
          component: PlanningArtwork,
          duration: 30
        },
        {
          key: 'analysis',
          component: AnalysisArtwork,
          duration: 40
        },
        {
          key: 'publicSpace',
          component: PublicSpaceArtwork,
          duration: 40
        }
      ]
    }
  },
  computed: {
    activeKey () {
      return this.currentArtwork > -1 ? this.artworks[this.currentArtwork].key : ''
    },
    nextArtwork () {
      return this.currentArtwork + 1 >= this.artworks.length ? 0 : this.currentArtwork + 1
    }
  },
  watch: {
    'inViewport.now' (visible) {
      if (visible) {
        this.visible = true
      }
    },
    visible () {
      if (this.visible) {
        setTimeout(this.changeArtwork.bind(this), 550)
      }
    }
  },
  mounted () {
    this.artworkAnimations = this.$refs.artworks.map((artwork, i) => (
      new Vivus(artwork.$el, { duration: this.artworks[i].duration, start: 'manual' }))
    )
  },
  methods: {
    changeArtwork () {
      const ANIMATION_OUT_DELAY = 3000
      this.artworkAnimations[this.nextArtwork].play(1, () => {
        setTimeout(() => {
          this.artworkAnimations[this.currentArtwork].play(-1.5, () => {
            this.changeArtwork()
          })
        }, ANIMATION_OUT_DELAY)
      })
      this.currentArtwork = this.nextArtwork
    }
  }
}
</script>

<style lang="scss" scoped>
  .artworks-section {
    &__header,
    &__artwork {
      @include grid-column((xs: 12));
    }

    &__heading {
      @include text(big, bold);
      min-height: 50px;
    }

    &__artwork {
      @include vertical-space((top: 1, bottom: 2));
      @include center-content;

      @include media-up(md) {
        @include vertical-space((top: 1, bottom: 4));
      }

      height: 8 * $vertical-space;

      &-item {
        width: 100%;
        height: 100%;
        max-width: 320px;
        margin-bottom: 5px;
        position: relative;
      }
    }

    &__svg {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Home/ArtworksSection.vue